import React, { useState } from 'react'
import Selection from './Selection.js'
import Review from './Review.js'

import './Reflection.scss'

const Reflection = props => {



    const data = props.data;

    const [phase, setPhase] = useState('selection');
    const [selected, setSelected] = useState(data.options.map(el => false));

    const onSelectionComplete = (data) => {
        setSelected(data)
        setPhase('review')
        // props.markComplete();
    }

    return (
        <div className={`Reflection`}>
            {/* <pre>
                {
                    JSON.stringify(data, null, 2)
                }
            </pre> */}

            {
                (phase === 'selection') &&
                <Selection data={data} onComplete={onSelectionComplete} />
            }

            {
                (phase === 'review') &&
                <Review data={data} selected={selected} onComplete={props.onComplete} resetSco={props.resetSco} />
            }

        </div>
    )
}

export default Reflection